// extracted by mini-css-extract-plugin
module.exports = {"container":"_3x-7yhdZ4KZ5H22IUBL79G"};